import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_01_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-01-01",
    "name": "凳上肩胛骨激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "thoracic",
    "tips": ["肩胛前引后缩", "控制动作节奏"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/e34dfc46a194dc9bd177987d.mp4",
    "videoUrl": "/media/collections-20261008/videos/74fef7da131a9b3c761e07e9.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第1期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-01-02",
    "name": "站立肩胸拉伸",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "chest",
    "tips": ["感受胸肩前侧拉伸", "每侧30秒"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/reviewed-6fbbca0f8b8bf179dd37eeda.mp4",
    "videoUrl": "/media/collections-20261008/videos/521a61e874caa9e76fd952c2.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第1期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-01-03",
    "name": "宽握高位下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["宽握距更大程度拉伸背阔", "拉至锁骨位置"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/ccb33c32e097f9f3702b5308.mp4",
    "videoUrl": "/media/collections-20261008/videos/bab631eddc767b50cca911ea.mp4",
    "targetMuscles": ["背阔肌", "肱二头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-01-04",
    "name": "绳索直臂下压",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "width",
    "tips": ["核心收紧，背部主导发力", "感受背阔肌延展与收缩"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "焚诀计划 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/233aabd28b2f4cbf77a6a2f0.mp4",
    "videoUrl": "/media/collections-20261008/videos/f08ad16d91a33842aa4ed92b.mp4",
    "targetMuscles": ["背阔肌", "大圆肌"],
    "difficulty": "intermediate",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
